import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import {
	BulkAssignCounterpartyJobStatus,
	type BulkAssignCounterpartyJobStatusState,
} from '@dealstack/shared/lib/common/bulkAssignCounterparty/jobStatus';
import { useBulkJobStatus } from './useBulkJobStatus';

const TERMINAL_STATUSES: readonly BulkAssignCounterpartyJobStatus[] = [
	BulkAssignCounterpartyJobStatus.COMPLETED,
	BulkAssignCounterpartyJobStatus.FAILED,
];

const buildStatusEndpoint = (dealId: string, programmeId: string, jobId: string): string =>
	`${formatUnicorn(API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_BULK_ASSIGN_COUNTERPARTY_POST, { dealId, programmeId })}-status/${jobId}`;

export const useBulkAssignCounterpartyStatus = ({
	dealId,
	programmeId,
	jobId,
	onTerminal,
}: {
	dealId: string;
	programmeId: string;
	jobId: string | null;
	onTerminal?: (state: BulkAssignCounterpartyJobStatusState) => void;
}) =>
	useBulkJobStatus<BulkAssignCounterpartyJobStatusState>({
		dealId,
		programmeId,
		jobId,
		queryKeyPrefix: 'bulk-assign-counterparty-status',
		buildStatusEndpoint,
		terminalStatuses: TERMINAL_STATUSES,
		onTerminal,
	});
